.container {
  display: none;
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    display: flex;
    gap: 20px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    display: flex;
    gap: 20px;
  }
}
